import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {navigator, router} from 'lit-element-router';

import {when} from 'lit/directives/when.js';

import store from '../../store';

import style from '../../../../scss/accounts.scss';
import formPageStyle from '../../../../scss/formPage.scss';
import arrowRight from '../../icons/arrowRight';
import {navigateTo} from '../../slices/statusSlice';
import getRoutes from '../../routes';
import plus from '../../icons/plus';


@customElement('arc-admin-subscriptions')
export class AdminSubscriptions extends connect(store)(router(navigator(LitElement))) {
	static styles = [formPageStyle, style];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.status = state.status;
		this.loggedIn = state.account.data.loggedIn;
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		this.params = params;
		this.query = query;
	}

	// handleAddSubscription() {
	// 		store.dispatch(navigateTo({route: 'admin-subscription', params: this.params}));
	// }

	render() {
		return html`
			<div class="subscriptions">
				<arc-toolbar class="toolbar">
					<div slot="left">
						<arc-breadcrumbs>
							<span>${msg('Subscriptions')}</span>
						</arc-breadcrumbs>
					</div>
					<div slot="right">
						<!--<arc-button
							title="${msg('Create New Subscription')}"
							type="primary"
							.additionalInfo="${false}"
							showLabel=${true}
							showIcon=${true}
							iconColor="ok"
							@click=${() => this.handleAddSubscription()}
						>${plus}</arc-button> -->
					</div>
				</arc-toolbar>

				${when(
					this.loggedIn,
					() => html`
						<arc-subscription-list class="subscriptionList"  .showFilter="${true}"></arc-subscription-list>`,
					() => html`
						<arc-routerlink class="requestToken" route="requestToken">
							${msg('Request Token')}
						</arc-routerlink>
					`
				)}

		`;
	}
}
